/* eslint-disable camelcase */
import { DateTime } from 'luxon';
import _ from 'lodash';

export const werkzeugnummer = {
  key: 'werkzeugnummer',
  sortable: true,
  label: 'Werkzeugnummer',
  tdClass: 'py-1',
};

export const werkzeugtyp = {
  key: 'werkzeugtyp',
  sortable: true,
  label: 'Typ',
  tdClass: 'py-1',
  formatter: (value) => value?.name || '',
  sortKey: 'wt.name',
};

export const kunde = {
  key: 'kunde',
  sortable: true,
  label: 'Kunde',
  sortKey: 'kunde.nummer',
  tdClass: 'py-1',
  formatter: (value) => {
    if (value) {
      return `${value.nummer || ''} ${value.name || ''}`;
    }
    return '';
  },
};

export const werkzeugstatus = {
  key: 'werkzeugstatus',
  sortable: true,
  sortKey: 'ws.name',
  label: 'Status',
  tdClass: 'py-1',
  formatter: (value) => value?.name || '',
};

export const werkzeugstatus2 = {
  key: 'werkzeugstatus2',
  sortable: true,
  sortKey: 'ws_2.name',
  label: 'Status',
  tdClass: 'py-1',
  formatter: (value) => value?.name || '',
};

export const benoetigt_ab = {
  key: 'benoetigt_ab',
  sortable: true,
  label: 'Benötigt Ab',
  tdClass: 'py-1',
  formatter: (val) => {
    if (val) return DateTime.fromMillis(val).toFormat('dd.MM.yyyy');
    return '';
  },
};

export const zieldatum = {
  key: 'zieldatum',
  sortable: true,
  label: 'Zieldatum',
  tdClass: 'py-1',
  formatter: (val) => {
    if (val) return DateTime.fromMillis(val).toFormat('dd.MM.yyyy');
    return '';
  },
};

export const spaetestes_startdatum = {
  key: 'spaetestes_startdatum',
  sortable: true,
  label: 'Verspätetes Zieldatum',
  tdClass: 'py-1',
  formatter: (val) => {
    if (val) return DateTime.fromMillis(val).toFormat('dd.MM.yyyy');
    return '';
  },
};

export const letzter_historie_kommentar = {
  key: 'letzter_historie_kommentar',
  sortable: true,
  label: 'Letzter Kommentar',
  tdClass: 'py-1',
  formatter: (val) => {
    const s = _.truncate(val, { length: 150 });
    return s;
  },
};
export const artikelnummer = {
  key: 'artikelnummer',
  sortable: true,
  label: 'Artikelnummer',
  tdClass: 'py-1',
  sortKey: 'h_artikel.artikelnummer',
};

export const artikelbezeichnung = {
  key: 'artikelbezeichnung',
  sortable: true,
  label: 'Artikelbezeichnung',
  tdClass: 'py-1',
  sortKey: 'h_artikel.artikelbezeichnung',
};

export const kavitaeten = {
  key: 'kavitaeten',
  sortable: true,
  label: 'Kavitäten',
  tdClass: 'py-1',
};

export const herstelldatum = {
  key: 'herstelldatum',
  sortable: true,
  label: 'Herstelldatum',
  tdClass: 'py-1',
  formatter: (val) => {
    if (val) return DateTime.fromMillis(val).toFormat('dd.MM.yyyy');
    return '';
  },
};

export const erstintriebnahme = {
  key: 'erstintriebnahme',
  sortable: true,
  label: 'Erstinbetriebnahme',
  tdClass: 'py-1',
  formatter: (val) => {
    if (val) return DateTime.fromMillis(val).toFormat('dd.MM.yyyy');
    return '';
  },
};

export const stammlagerort = {
  key: 'stammlagerort',
  sortable: true,
  label: 'Stammlagerort',
  sortKey: 's_lagerort.name',
  tdClass: 'py-1',
  formatter: (value) => value?.name,
};

export const anzahl_reparatur = {
  key: 'anzahl_reparatur',
  sortable: true,
  label: 'Anzahl Reparaturen',
  sortKey: 'anzahl_reparatur',
  tdClass: 'py-1 text-right',
};

export const anzahl_wartung = {
  key: 'anzahl_wartung',
  sortable: true,
  label: 'Anzahl Wartungen',
  sortKey: 'anzahl_wartung',
  tdClass: 'py-1 text-right',
};

export const anzahl_fast_lane_reparatur = {
  key: 'anzahl_fast_lane_reparatur',
  sortable: true,
  label: 'Anzahl Fast Lane',
  sortKey: 'anzahl_fast_lane_reparatur',
  tdClass: 'py-1 text-right',
};

export const naechsteFunktionspruefungBeiMenge = {
  key: 'funktionspruefung_naechste_pruefung_bei_fertigungsmenge',
  label: 'FP. bei Menge',
  tdClass: (value, name, row) => {
    if (row && row.funktionspruefung_nach_fertigungsmenge_faellig) {
      return 'py-1 text-center text-danger font-weight-bold alert-danger';
    } if (row && row.funktionspruefung_nach_fertigungsmenge_anstehend) {
      return 'py-1 text-center font-weight-bold alert-warning';
    }
    return 'py-1 text-center';
  },
  formatter: (value, name, row) => {
    if (value && row.funktionspruefung_fertigungsmenge) {
      return `${row.funktionspruefung_fertigungsmenge} / ${value}${row.funktionspruefung_nach_fertigungsmenge_percent ? ` (${row.funktionspruefung_nach_fertigungsmenge_percent}%)` : ''}`;
    }
    return '';
  },
};

export const naechsteFunktionspruefungImMonat = {
  key: 'funktionspruefung_zeit_naechste_pruefung',
  label: 'FP. im Monat',
  tdClass: (value, name, row) => {
    if (row && row.funktionspruefung_nach_zeit_faellig) {
      return 'py-1 text-center text-danger font-weight-bold alert-danger';
    } if (row && row.funktionspruefung_nach_zeit_anstehend) {
      return 'py-1 text-center font-weight-bold alert-warning';
    }
    return 'py-1 text-center';
  },
  formatter: (value) => {
    if (value) return DateTime.fromMillis(value).setLocale('de').toFormat('MMMM yyyy');
    return '';
  },
};

export const letzteFunktionspruefung = {
  key: 'funktionspruefung_letzte_pruefung',
  label: 'Letzte FP.',
  tdClass: 'py-1 text-center',
  formatter: (value, name, row) => {
    const parts = [];
    if (row.funktionspruefung_nach_zeit && row.funktionspruefung_zeit_letzte_pruefung > 0) {
      parts.push(`${DateTime.fromMillis(row.funktionspruefung_zeit_letzte_pruefung).setLocale('de').toFormat('dd.MM.yy')}`);
    }
    if (row.funktionspruefung_fertigungsmenge && row.funktionspruefung_letzte_pruefung_bei_fertigungsmenge) {
      parts.push(`${row.funktionspruefung_letzte_pruefung_bei_fertigungsmenge} Stück`);
    }

    return parts.join('\n');
  },
};

export const funktionspruefungZyklus = {
  key: 'funktionspruefung_zyklus',
  sortable: false,
  label: 'FP. Zyklus',
  tdClass: 'py-1 text-center',
  formatter: (value, name, row) => {
    const parts = [];
    if (row.funktionspruefung_fertigungsmenge && row.funktionspruefung_pruefzyklus > 0) {
      parts.push(`${row.funktionspruefung_pruefzyklus} Stück`);
    }
    if (row.funktionspruefung_nach_zeit && row.funktionspruefung_nach_zeit > 0) {
      parts.push(`${row.funktionspruefung_zeit_intervall} ${row.funktionspruefung_zeit_intervall_type}`);
    }
    return parts.join('\n');
  },
};

export default {
  stammliste: [
    werkzeugstatus,
  ],
  werkzeugbau: [
    werkzeugstatus2,
    benoetigt_ab,
    zieldatum,
    spaetestes_startdatum,
    letzter_historie_kommentar,
  ],
  possibleFields: [
    werkzeugstatus,
    werkzeugstatus2,
    artikelnummer,
    artikelbezeichnung,
    kavitaeten,
    herstelldatum,
    erstintriebnahme,
    stammlagerort,
    anzahl_reparatur,
    anzahl_fast_lane_reparatur,
    anzahl_wartung,
    naechsteFunktionspruefungBeiMenge,
    naechsteFunktionspruefungImMonat,
    funktionspruefungZyklus,
    letzteFunktionspruefung,
  ],
};
